export const environment = {
  production: true,
  IP_DATA_URL: 'https://api.ipdata.co',
  IP_DATA_KEY: 'fa14969ac4163b4b19874b534fdd0ba59824cdd8ee3975aa95c7c7ce',
  API_URL: 'https://api.millionsolutions.dev',
};
